import {
  FunctionComponent,
  useCallback,
  useEffect,
  useState,
  memo,
} from 'react'
import { MdPlayArrow } from 'react-icons/md'

import { steps } from '../../'
import Radio from 'shared/components/Radio'
import Button from 'shared/components/Button'
import { colors } from 'shared/styles/colors'
import { Container, ContainerTerms, StyledPage, Term } from './styles'
import { ITermsProps } from './TermsComponent.types'

const Terms: FunctionComponent<ITermsProps> = ({
  setSelectedStep,
  findTerms,
}) => {
  const [terms, setTerms] = useState('')
  const [termsOk, setTermsOk] = useState(false)

  useEffect(() => {
    async function fetchTerms() {
      try {
        const response = await findTerms.execute()

        setTerms(response)
      } catch (error) {}
    }

    fetchTerms()
  }, [findTerms])

  const handleOnTermsOk = useCallback(() => {
    setTermsOk(true)
  }, [])

  return (
    <StyledPage title="TERMOS DE USO">
      <Container>
        <ContainerTerms>
          <div
            style={{
              display: 'flex',
              flexDirection: 'column',
              justifyContent: 'center',
              alignItems: 'center',
              paddingBottom: '0px',
            }}
          >
            <Term dangerouslySetInnerHTML={{ __html: terms }} />
          </div>
          <Radio
            id="terms"
            name="term"
            value="term"
            label="Li, entendi e estou de acordo com os Termos de Uso"
            textColor={colors.white}
            onChange={handleOnTermsOk}
            borderColor={colors.white}
            indicatorColor={colors.white}
          />
        </ContainerTerms>

        <Button
          color={termsOk ? colors.green : colors.grayLight}
          disabled={!termsOk}
          onClick={() => {
            setSelectedStep(steps.Email)
          }}
        >
          <MdPlayArrow /> Próximo
        </Button>
      </Container>
    </StyledPage>
  )
}

export default memo(Terms)
